import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import store, { persistedStore } from './redux/store';
import './i18n';

import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/index.css';

import "@fontsource/open-sans";
import "@fontsource/quicksand";

import App from './App';

// CSP Policy for FA icons
import { config as faConfig } from '@fortawesome/fontawesome-svg-core';
import "../node_modules/@fortawesome/fontawesome-svg-core/styles.css";
import { ToastContainer } from 'react-toastify';
import LoadingSpinner from './components/common/LoadingSpinner/LoadingSpinner';
import { FormErrorProvider } from './utils/context/FormErrorContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck, faCircleExclamation, faCircleInfo, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FormWarningProvider } from './utils/context/FormWarningContext';

faConfig.autoAddCss = false;

// Initialize google analytics
if ("REACT_APP_GA_ID" in process.env) {
  ReactGA.initialize(
    [
      {
        trackingId: process.env.REACT_APP_GA_ID as string,
        gaOptions: {
          debug_mode: true,
        }
      }
    ]
  );
  console.log('Initialized GA tool', process.env.REACT_APP_GA_ID)
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <FormErrorProvider>
      <FormWarningProvider>
        <PersistGate persistor={persistedStore} loading={<LoadingSpinner loading={true} />}>
          <React.StrictMode>
            <App />
            <ToastContainer icon={({ type }) => {
              switch (type) {
                case 'info':
                  return <FontAwesomeIcon icon={faCircleInfo} className='aoda-info' size="xl" />;
                case 'error':
                  return <FontAwesomeIcon icon={faCircleExclamation} className='aoda-error' size="xl" />;
                case 'success':
                  return <FontAwesomeIcon icon={faCircleCheck} className='aoda-success' size="xl" />;
                case 'warning':
                  return <FontAwesomeIcon icon={faTriangleExclamation} className='aoda-warning' size="xl" />;
                default:
                  return null;
              }
            }} />
          </React.StrictMode>
        </PersistGate>
      </FormWarningProvider>
    </FormErrorProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
